import type { Card, Vote } from "shared/model/retro/retroRoom.interface";

export const groupCards = (cards: Card[], votes: Vote[]): Group[] => {
  return cards
    .filter((c) => c.parentCardId === null)
    .map((parent) => {
      const groupCards = [
        parent,
        ...cards.filter((c) => c.parentCardId === parent.id),
      ];
      const count = groupCards
        .map((c) => votes.filter((v) => v.parentCardId === c.id))
        .reduce((a, c) => a.concat(c), []);

      return {
        parentCardId: parent.id,
        cards: groupCards,
        votes: count,
      };
    });
};

export interface Group {
  parentCardId: string;
  votes: Vote[];
  cards: Card[];
}
